import { Navigate, Outlet, type RouteObject } from 'react-router-dom';

import { FlaggedComponent } from '@myphx-engineering/feature-flags/client';

import type { FlagSet } from '../../generated/feature-flags';
import { getAbsoluteRoute } from '../../util';
import routes from '../app-routes';

import { SimplifiedOrderConfirmationRoute } from './SimplifiedOrderConfirmationRoute';
import { SimplifiedPreviewDetailsRoute } from './SimplifiedPreviewDetailsRoute';
import { SimplifiedProviderSelectionRoute } from './SimplifiedProviderSelectionRoute';

const simplifiedProvidersRoutes: RouteObject[] = [
    {
        path: routes.direct.root,
        element: (
            <FlaggedComponent<FlagSet>
                flag="enableSimplifiedFlow"
                fallback={
                    <Navigate to={getAbsoluteRoute('root')} replace={true} />
                }
            >
                <Outlet />
            </FlaggedComponent>
        ),
        children: [
            {
                path: routes.direct.drxId.root,
                element: <Outlet />,
                children: [
                    {
                        path: routes.direct.drxId.providers,
                        element: <SimplifiedProviderSelectionRoute />,
                    },
                    {
                        path: routes.direct.drxId.confirmation,
                        element: <SimplifiedOrderConfirmationRoute />,
                    },
                    {
                        path: routes.direct.drxId.providerId.root,
                        element: <Outlet />,
                        children: [
                            {
                                path: routes.direct.drxId.providerId.details,
                                element: <SimplifiedPreviewDetailsRoute />,
                            },
                        ],
                    },
                ],
            },
        ],
    },
];

export default simplifiedProvidersRoutes;
